import { BrowserGateShell } from "../components/BrowserGateShell";
import { APP_STORE_URL, SETBACK_DEEP_LINK } from "../lib/appClient";

export default function OpenInAppPage() {
  return (
    <BrowserGateShell>
      <h1 className="text-3xl font-bold tracking-tight sm:text-4xl">Open in the Setback Pitch app</h1>
      <p className="mt-3 text-lg text-white/80">
        You&apos;re on iPhone or iPad — tap below to continue in the app.
      </p>

      <a
        href={SETBACK_DEEP_LINK}
        className="mt-10 inline-flex w-full max-w-xs items-center justify-center rounded-xl bg-emerald-500 px-6 py-3.5 text-base font-semibold text-slate-900 shadow-lg transition hover:bg-emerald-400 focus:outline-none focus:ring-2 focus:ring-emerald-300 focus:ring-offset-2 focus:ring-offset-[#0f3d25]"
      >
        Open Setback Pitch
      </a>

      <a
        href={APP_STORE_URL}
        className="mt-4 inline-block text-sm font-medium text-emerald-300 underline underline-offset-4 transition hover:text-emerald-200"
      >
        Download on the App Store
      </a>
    </BrowserGateShell>
  );
}
